export const AGENT_INFO_KEY = 'dapscnect-agent';
export const AGENT_TOKEN_KEY = 'dapscnect-agent-token';